import Vue from 'vue'
import Router from 'vue-router'
import util from '@/utils'
import store from '@/store'
import NProgress from 'nprogress' // nprogress插件
import { getDoctorInformation } from "@/api";

Vue.use(Router)

let whiteList = ['/login', '/register', '/forget', '/film'];

//解决路由堆叠问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    routes: [{
            path: '/',
            // redirect: '/index/work/consultation'
            redirect: '/index/work/patients'
        },
        {
            path: '/index',
            component: () =>
                import ('@/views/index/layout.vue'),
            children: [{
                    path: '/index/work',
                    component: () =>
                        import ('@/views/work/work.vue'),
                    children: [{
                            path: '/index/work/patients',
                            component: () =>
                                import ('@/views/work/children/patients.vue')
                        },
                        {
                            path: '/index/work/appointment',
                            component: () =>
                                import ('@/views/work/children/appointment.vue')
                        }, {
                            path: '/index/work/consultation',
                            component: () =>
                                import ('@/views/work/children/consultation.vue')
                        }, {
                            path: '/index/work/videoment',
                            component: () =>
                                import ('@/views/work/children/videoment.vue')
                        },

                    ]
                },
                {
                    path: '/index/work/slice',
                    component: () =>
                        import ('@/views/slice/index.vue')
                },
                {
                    path: '/index/user',
                    component: () =>
                        import ('@/views/users/user.vue'),
                    children: [{
                            path: '/index/user/patients',
                            component: () =>
                                import ('@/views/users/children/patients.vue')
                        },
                        {
                            path: '/index/user/auditInformation',
                            component: () =>
                                import ('@/views/users/children/auditInformation/auditInformation.vue'),
                            children: [{
                                    path: 'qualifications',
                                    component: () =>
                                        import ('@/views/users/children/auditInformation/children/qualifications.vue')
                                },
                                {
                                    path: 'information',
                                    component: () =>
                                        import ('@/views/users/children/auditInformation/children/information.vue')
                                },
                                {
                                    path: 'authentication',
                                    component: () =>
                                        import ('@/views/users/children/auditInformation/children/authentication.vue')
                                },
                                {
                                    path: 'auditInfo',
                                    component: () =>
                                        import ('@/views/users/children/auditInformation/children/auditInfo.vue')
                                },
                                {
                                    path: '',
                                    redirect: 'information'
                                }
                            ]
                        },
                        {
                            path: '/index/user/userInfo',
                            component: () =>
                                import ('@/views/users/children/userInfo.vue')
                        },
                        {
                            path: '/index/user/serveInfo',
                            component: () =>
                                import ('@/views/users/children/serveInfo.vue')
                        },
                        {
                            path: '/index/user/news',
                            component: () =>
                                import ('@/views/users/children/news.vue')
                        },
                        {
                            path: '/index/user/wallet',
                            component: () =>
                                import ('@/views/users/children/wallet.vue'),
                        },
                        {
                            path: '/index/user/wallet/cashLog',
                            component: () =>
                                import ('@/views/users/children/cashLog.vue'),
                        },
                        {
                            path: '/index/user/setup',
                            component: () =>
                                import ('@/views/users/children/setup.vue')
                        },
                        {
                            path: '/index/user/report',
                            component: () =>
                                import ('@/views/users/children/report.vue')
                        },
                        {
                            path: '/index/user/wallet/addCash',
                            component: () =>
                                import ('@/views/users/children/addCash.vue')
                        },
                        {
                            path: '/index/user/attendance',
                            component: () =>
                                import ('@/views/users/children/attendance.vue')
                        },
                        {
                            path: '/index/user/reportManage',
                            component: () =>
                                import ('@/views/users/children/reportManage.vue')
                        },
                        {
                            path: '/index/user/replenishment',
                            component: () =>
                                import ('@/views/users/children/replenishment.vue')
                        },
                        {
                            path: '/index/user/prescription',
                            component: () =>
                                import ('@/views/users/children/prescription.vue')
                        },
                        {
                            path: '/index/user/prescription/prescriptionDetails',
                            component: () =>
                                import ('@/views/users/children/prescriptionDetails.vue')
                        },
                        {
                            path: '/index/user/appointmentList',
                            component: () =>
                                import ('@/views/users/children/appointmentList.vue')
                        },
                        {
                            path: '/index/user/moneyBack',
                            component: () =>
                                import ('@/views/users/children/moneyBack.vue')
                        },
                        {
                            path: '/index/user/adverseReaction',
                            component: () =>
                                import ('@/views/users/children/adverseReaction.vue')
                        },
                        {
                            path: '/index/user/remoteInterrogation',
                            component: () =>
                                import ('@/views/users/children/remoteInterrogation.vue')
                        }, {
                            path: '/index/user/transfer',
                            component: () =>
                                import ('@/views/users/children/transfer.vue')
                        },
                        {
                            path: '/index/user/adverseReaction/adverseReactionDetail',
                            component: () =>
                                import ('@/views/users/children/adverseReactionDetail.vue')
                        },
                    ]
                },
                {
                    path: '/index/work/workDetail',
                    name: 'workDetail',
                    component: () =>
                        import ('@/views/workDetail/index.vue')
                },
                {
                    path: '/index/work/patientDetails',
                    name: 'patientDetails',
                    component: () =>
                        import ('@/views/work/children/patientDetails.vue')
                },

                {
                    path: '/index/work/chart',
                    name: 'chart',
                    component: () =>
                        import ('@/views/chart/index.vue')
                },
                // TODO 聊天简化
                {
                    path: '/index/work/doctorChart',
                    name: 'chart',
                    component: () =>
                        import ('@/views/doctorChart/index.vue')
                },
                { // 处方详情
                    path: '/index/work/prescriptionDetail',
                    name: 'chart',
                    component: () =>
                        import ('@/views/prescriptionDetail/detail.vue')
                }

            ]
        },
        {
            path: '/netcall',
            name: 'netcall',
            component: () =>
                import ('@/views/netcall/index.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('@/views/login/index.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () =>
                import ('@/views/register/index.vue')
        },
        {
            path: '/forget',
            name: 'forget',
            component: () =>
                import ('@/views/forget/index.vue')
        },
        {
            path: '/lock',
            name: 'lock',
            component: () =>
                import ('@/components/common/lock.vue')
        },
        {
            path: '/film',
            name: 'film',
            component: () =>
                import ('@/components/common/film.vue')
        },
        {
            path: '/main',
            name: 'main',
            component: () =>
                import ('@/components/main/main.vue')
        }
    ]
})
router.beforeEach((to, form, next) => {
    let user_token = util.getStore('user_token');
    let lockState = util.getStore('lockState');
    let toPath = to.path
        // console.log('to',to,'form',form);
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
        // safari
    window.pageYOffset = 0
        //判断锁屏
    if (lockState === '0' && to.path !== '/lock' && user_token) {
        console.log("to.fullPath:", to.fullPath);
        next({
            path: '/lock',
            query: { redirect: to.fullPath }
        })
    } else if (whiteList.indexOf(toPath) == -1 && !user_token) {

        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });　　 //这行是重点，解决登录后不能回退页面bug的原因就在这
        //开始进度条
        NProgress.start();
    } else if (whiteList.indexOf(toPath) == -1 && user_token) {
        //开始进度条
        NProgress.start();
        // 刷新用户信息
        store.dispatch("connect");
        store.dispatch("updateRefreshState");
        const token = localStorage.getItem("user_token");
        token && getDoctorInfor();
        next()
    } else {
        next()
    }

    function getDoctorInfor() {
        getDoctorInformation().then((res)=>{
            if (res.code === 1) {
                store.commit("setStatus", res.data.status);
                util.setStore("userInfo", res.data);
            }
        })
    }
});
router.afterEach(transition => {
    //结束进度条
    NProgress.done();
});
export default router;